// 新聞頁面 - 按讚表情符號
import Image from 'next/image';

const NewsEmoji = ({ t, location, emojis, onThumb = () => {}, onClickEmoji = () => {} }) => {
    // 是否為手機版置底
    const isBottom = location === 'bottom';

    return (
        // 點擊按讚 hover 顯示更多 emoji
        <div className="relative group !z-[1]">
            {!isBottom && (
                <div
                    className="cp px-[20px] py-[6px] center-center rounded-[6px] trans gap-x-[16px] group-hover:bg-bou"
                    onClick={onThumb}
                >
                    <div className="img-box w-[26px] aspect-[1]">
                        <Image
                            width={26}
                            height={26}
                            src="/images/icon/icon_thumbs.svg"
                            alt="icon"
                        />
                    </div>

                    <span className="text-btn1 text-white flex-shrink-0">{t('THUMB')}</span>
                </div>
            )}

            <div
                className={`items-center z-[1]
                ${
                    isBottom
                        ? 'flex p-[8px] justify-around bg-[rgba(0,0,0,.7)] backdrop-blur-[10px]'
                        : 'bg-black justify-between hidden absolute pl-[15px] left-[100%] top-[50%] translate-y-[-50%] h-[calc(100%+2px)] w-[calc(680px-112px)] group-hover:flex'
                }`}
            >
                {emojis
                    ?.filter((v) => v?.id !== 'thumb')
                    ?.map((emoji, i) => (
                        <button
                            key={'emoji' + i}
                            className="w-[40px] aspect-[1]"
                            onClick={() => onClickEmoji(emoji?.id)}
                        >
                            <Image
                                className={`${isBottom ? '' : 'trans hover:translate-y-[-3px]'}`}
                                width={40}
                                height={40}
                                src={emoji?.img}
                                alt="icon"
                            />
                        </button>
                    ))}
            </div>
        </div>
    );
};

export default NewsEmoji;
